import React from "react";
import { Helmet } from "react-helmet";
import { profile } from "./content";

export default function SiteMeta({
  title,
  description,
  path = "/",
  noindex = false,
}) {
  const fullTitle = title
    ? `${title} | Hunter Grey`
    : "Hunter Grey | Developer & builder";
  const summary =
    description ||
    "Developer tools, offline-first personal apps, and self-hosted infrastructure. Recent work by Hunter Grey on NeoVibe, Skuld, and draupnir.";
  const url = `${profile.site}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={summary} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={summary} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta
        name="robots"
        content={noindex ? "noindex, follow" : "index, follow"}
      />
      <link rel="canonical" href={url} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          name: profile.name,
          url: profile.site,
          sameAs: [profile.github, profile.gitlab, profile.linkedin],
        })}
      </script>
    </Helmet>
  );
}
